import { EMPTY_ARRAY, fetchProviderByIds, WaterProvider } from "../misc";
import { queryKpisOpenData } from "../misc/kpiOpenApi";
import { KpiReport } from "../processors";

export const getKpiResultsAndProviders = async (
    kpis?: string[][],
    locationAdminIds?: string[],
    continueAfterGettingProvidersFn?: (providers: WaterProvider[]) => boolean
): Promise<{
    providers: WaterProvider[];
    results: KpiReport[];
}> => {
    const allow =
        !kpis ||
        !kpis.filter(d => d != null).length ||
        !locationAdminIds ||
        !locationAdminIds.filter(d => d != null && d.toString().trim() !== "")
            ? false
            : true;

    if (!allow)
        return {
            providers: EMPTY_ARRAY,
            results: EMPTY_ARRAY
        };

    const providers = await fetchProviderByIds(locationAdminIds);

    // const valid = locationAdminIds.filter(d => d != null && d.toString().trim() !== "");
    // // query providers by locationAdminIds
    // const query = _.join(valid, " OR ");
    // const solrQuery = _.join(
    //     [
    //         "q=*:*",
    //         "rows=1000",
    //         `fq=pure_strings_admin_id:(${query})`,
    //         // "fl=pure_strings_sname,pure_strings_admin_id,its_tid"
    //         `fl=${PROVIDER_FIELDS}`
    //     ],
    //     QUERY_URL_AND
    // );

    // const providers = await queryWaterProviderWithDocs(solrQuery);
    // , {
    //     cache: valid?.length === 1 ? "force-cache" : "no-cache"
    //     // cache: "force-cache"
    // });

    const con = !continueAfterGettingProvidersFn ? true : continueAfterGettingProvidersFn(providers);

    if (!con) {
        return {
            providers: [],
            results: []
        };
    }
    const results = await queryKpisOpenData(
        {
            providerNames: providers.map(d => d.kapiName),
            kpis
        },
        providers,
        {
            cache: "force-cache"
        }
    );

    return {
        providers,
        results
    };
};
export const getCountKpisForProviders = async (kpis?: string[][], locationAdminIds?: string[]): Promise<number> => {
    const { results } = await getKpiResultsAndProviders(kpis, locationAdminIds);
    const nullResults = results?.filter(d => d.value == null);

    return results?.length === nullResults?.length
        ? 0
        : results.filter(d => d.value != null || d.valueStatus != null).length;

    // const allow =
    //     !kpis ||
    //     !kpis.filter(d => d != null).length ||
    //     !locationAdminIds ||
    //     !locationAdminIds.filter(d => d != null && d.toString().trim() !== "")
    //         ? false
    //         : true;

    // if (!allow) return 0;
    // const valid = locationAdminIds.filter(d => d != null && d.toString().trim() !== "");
    // // query providers by locationAdminIds
    // const query = _.join(valid, " OR ");
    // const solrQuery = _.join(
    //     [
    //         "q=*:*",
    //         "rows=1000",
    //         `fq=pure_strings_admin_id:(${query})`,
    //         // "fl=pure_strings_sname,pure_strings_admin_id,its_tid"
    //         `fl=${PROVIDER_FIELDS}`
    //     ],
    //     QUERY_URL_AND
    // );

    // const providers = await queryWaterProviderWithDocs(solrQuery);
    // // , {
    // //     cache: valid?.length === 1 ? "force-cache" : "no-cache"
    // //     // cache: "force-cache"
    // // });

    // const results = await queryKpisOpenData(
    //     {
    //         providerNames: providers.map(d => d.name),
    //         kpis
    //     },
    //     providers,
    //     {
    //         cache: "force-cache"
    //     }
    // );

    // // query some sample providers (large) and decide if the data is accepted
    // // only accepting data if data is really up-to-date, given the current latest year of large providers
    // // const sampleProviderQuery = _.join(
    // //     [
    // //         "q=*:*",
    // //         "rows=1",
    // //         `fq=pure_strings_connection_size_ct:(large)`,
    // //         //"fl=pure_strings_sname,pure_strings_admin_id,its_tid"
    // //         `fl=${PROVIDER_FIELDS}`
    // //     ],
    // //     QUERY_URL_AND
    // // );
    // // const sampleProviders = await queryWaterProviderWithDocs(sampleProviderQuery);
    // // const sampleResults = await queryKpisOpenData(
    // //     {
    // //         providerNames: sampleProviders.map(d => d.name),
    // //         kpis
    // //     },
    // //     sampleProviders,
    // //     {
    // //         cache: "force-cache"
    // //     }
    // // );

    // // const year = _.max(sampleResults?.map(d => d.year)) - 2;

    // // if a non-trivial data exists, then accept it to display
    // return results.filter(d => d.value != null || d.valueStatus != null).length;
};
